<template>
  <ProjectBaseView>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <ElementTypesCount />
        </v-col>
        <v-col cols="12" md="6">
          <KanbanStatus />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <TimeLeft 
            title="Tiempo restante"
            :startDate="project.projectDateI"
            :endDate="project.projectDateT"
          />
        </v-col>
      </v-row>
    </v-container>
  </ProjectBaseView>
</template>

<script>
import ElementTypesCount from "@/components/metrics/ElementTypesCount.vue";
import ProjectBaseView from "./ProjectBaseView.vue";
import KanbanStatus from "@/components/metrics/KanbanStatus.vue";
import TimeLeft from "@/components/metrics/TimeLeft.vue";

export default {
  name: "MetricsView",
  components: {
    ProjectBaseView,
    ElementTypesCount,
    KanbanStatus,
    TimeLeft
  },
  computed: {
    project() {
      return this.$store.state.project || {};
    }
  }
}
</script>